import React from 'react'
import './ITOpsContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'
import { FaClipboardList, FaSyncAlt, FaUsers, FaBullseye } from 'react-icons/fa'

export class ITOpsContent extends React.Component {
  render() {
    return (
      <div className="it-ops-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Rackner delivers enterprise IT operations with proven 99.9%+
            historical system availability across its programs, earning
            recognition including a Franklin Award from the State Department for
            Systems Administration Intelligence work.
          </div>
        </div>

        <section className="padding-large">
          <h2>24/7/365 Operational Excellence</h2>
          <div className="row highlight-stats">
            <div className="col-md-4">
              <div className="stat-box">
                <div className="number">120,000+</div>
                <div className="label">Users Supported</div>
                <div className="detail">
                  Mission-critical systems for Homeland Security Information
                  Network (HSIN)
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="stat-box">
                <div className="number">99.9%+</div>
                <div className="label">Historical Availability</div>
                <div className="detail">
                  Proven uptime across all programs including emergency response
                  operations
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="stat-box">
                <div className="number">100%</div>
                <div className="label">DoD 8570/8140 Compliance</div>
                <div className="detail">
                  All IT Ops personnel meet or exceed certification requirements
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Proactive Operations Approach</h2>
          <div className="row ops-capabilities">
            <div className="col-md-6">
              <div className="ops-card">
                <div className="title">Configuration as Code</div>
                <div className="description">
                  Ansible-based infrastructure automation provides a single source
                  of truth, enabling rapid recovery and consistent deployments
                  across environments.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="ops-card">
                <div className="title">Automated Monitoring</div>
                <div className="description">
                  Comprehensive observability with Splunk, Prometheus, and Grafana
                  providing real-time alerts and predictive insights.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="ops-card">
                <div className="title">Drift Detection</div>
                <div className="description">
                  Automated configuration drift detection ensures systems remain
                  compliant with baseline configurations and security policies.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="ops-card">
                <div className="title">Zero-Downtime Patching</div>
                <div className="description">
                  Rolling update strategies with automated rollback capabilities
                  maintain availability during maintenance windows.
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <h2>Technology Portfolio</h2>
          <div className="row tech-row">
            <div className="col-md-4">
              <div className="tech-block">
                <h3>Operating Systems</h3>
                <ul>
                  <li>Windows Server (2016, 2019, 2022)</li>
                  <li>Red Hat Enterprise Linux</li>
                  <li>Ubuntu LTS</li>
                  <li>Container runtimes (Docker, containerd)</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="tech-block">
                <h3>Cloud Platforms</h3>
                <ul>
                  <li>AWS GovCloud (IL2-IL5)</li>
                  <li>Azure Government (IL5)</li>
                  <li>On-premise private cloud</li>
                  <li>Hybrid cloud architectures</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="tech-block">
                <h3>Compliance</h3>
                <ul>
                  <li>FedRAMP High</li>
                  <li>NIST SP 800-53</li>
                  <li>DISA STIGs</li>
                  <li>Agency-specific directives</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div className="split">
          <h2>Operational Excellence Practices</h2>
          <div className="practices-list">
            <div className="practice-item">
              <div className="icon"><FaClipboardList /></div>
              <div className="content">
                <div className="title">Comprehensive Documentation</div>
                <div className="description">
                  Detailed runbooks, architecture diagrams, and change logs
                  maintained in version control for full transparency.
                </div>
              </div>
            </div>
            <div className="practice-item">
              <div className="icon"><FaSyncAlt /></div>
              <div className="content">
                <div className="title">Disaster Recovery Planning</div>
                <div className="description">
                  Regular backup verification, tested recovery procedures, and
                  documented RTO/RPO objectives.
                </div>
              </div>
            </div>
            <div className="practice-item">
              <div className="icon"><FaUsers /></div>
              <div className="content">
                <div className="title">User Profile Management</div>
                <div className="description">
                  Quarterly access audits, least-privilege enforcement, and
                  automated de-provisioning workflows.
                </div>
              </div>
            </div>
            <div className="practice-item">
              <div className="icon"><FaBullseye /></div>
              <div className="content">
                <div className="title">Incident Response</div>
                <div className="description">
                  Defined escalation paths, blameless post-mortems, and
                  continuous improvement from lessons learned.
                </div>
              </div>
            </div>
          </div>
          <div className="button-wrap">
            <Link to="/contact">
              <button className="btn-raised-light-blue-inverse big">
                Modernize Your Operations
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default ITOpsContent
